import React from 'react'
import PropTypes from 'prop-types'
import ClientCase from './ClientCase'
import Popin from './../Popin'

/**
   * @class ClientsCases
   * @props {string} origin
   * gives the page where the composant is called.
   * Not required but must be known - home by default
   * @props {string} classes
   * gives the CSS classes for <ClientCase />
   * Not required - empty by default
   * @props {array} slice
   * gives the datas which have to be returned
   * Not required, but must be an array of 1 or 2 numbers - 0 by default (returns all)
*/

class ClientsCases extends React.Component {

  clientsDetails: object[] = []

  /**
     * @class ClientsCases
     * Constructor
     * clientsdetails is an array of objects with informations about clients
     * It will be a json flux from WP later
  */
  constructor(props) {
    super(props)
    this.state = {
      clientId : 0,
      articles  : [],
      isLoading : false,
      error     : null
    }

    /*if (this.props.origin === "work") {
    } else {
    }*/
  }

  /**
    * @class ClientsCases
    * @method componentDidMount
    * 
  */
  componentDidMount() {
    this.setState({isLoading: true})
    fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/wp/v2/cas_clients/?orderby=menu_order&order=asc&per_page=100`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    })
    .then(response => {
      if (response.ok) { return response.json() }
      else throw new Error("Une erreur s'est produite.")
    })
    .then(articles => {
      let filteredArticles = [];
      const isOriginHome = this.props.origin === "home";
      const limit = isOriginHome ? 6 : 100;
      let articlesCount = 0;
      articles.some(article => {
        // Handle articles depending on the origin:
        // - keep only 6 first minor cases for "home";
        // - keep all major and minor for "work";
        if (!isOriginHome || (article.acf && (!article.acf.caseType || article.acf.caseType === "0")) ) {
          filteredArticles.push(article);
          // Break loop upon reaching the limit.
          if (++articlesCount >= limit) {
            return true;
          }
        }
        return false;
      });
      // Update component state.
      this.setState({
        articles: filteredArticles,
        isLoading: false
      })
    })
    .catch(error => this.setState({ error, isLoading: false }))
  }

  /**
    * @class ClientsCases
    * @method getClientsDetails
    * Calls ClientCase component for each object in clientsDetails
  */
  getClientsDetails() {
    if (this.state.articles.length > 0) {
      this.clientsDetails = this.state.articles
      return this.clientsDetails.map((clientDetails, index) =>
        <ClientCase selectedClient={this.setClientState.bind(this, clientDetails.id)}
          key={index} details={clientDetails} classes={this.props.classes} />
      )
    }
  }

  setClientState(param, event) {
    this.setState({clientId: param})
  }

  getClientDetails() {
    return this.clientsDetails
      .filter(clientDetails => clientDetails.id === this.state.clientId)
      .map((clientDetails, index) => <Popin key={index} details={clientDetails} />
    )
  }

  render() {
    if (this.state.error) {
      return <p>{this.state.error.message}</p>
    }

    if (this.state.isLoading) {
      return <p>Chargement des articles...</p>
    }
    return (
      <section className="bg--black">
        { this.getClientDetails() }
        <div className="row no-gutters">
          { this.getClientsDetails() }
        </div>
      </section>
    )
  }
}

/**
  * Props typing
*/
ClientsCases.propTypes = {
  classes: PropTypes.string,
  origin: function(props, propName, componentName) {
    /* All possible origins must be added here */
    if(! ['home','work'].includes(props[propName])) {
      return new Error('Prop origin is unknown in ' + componentName)
    }
  },
  slice: PropTypes.arrayOf(function(propValue, key, componentName) {
    /* Only 1 or 2 numbers should be in slice */
    if ((isNaN(propValue[key])) || (key > 1)) {
      return new Error('Prop slice should be an array of 1 or 2 numbers in ' + componentName)
    }
  })
}

/**
  * Props by default
*/
ClientsCases.defaultProps = {
  origin: "home",
  classes: "",
  slice: [0]
};

export default ClientsCases


// WEBPACK FOOTER //
// ./src/components/ClientsCases/index.jsx